import Vue from 'vue';
import Component from 'vue-class-component';
import {Fragment} from 'vue-fragment';
import {LoginState} from '../Types/LoginState';
import {setLoginStateGlobally} from '../Functions/LoginStateUtility';
import LoginWorldWide from './LoginWorldWide/LoginWorldWide.vue';
import LoginExtranet from './LoginExtranet/LoginExtranet.vue';
import LoginMobile from './LoginMobile/LoginMobile.vue';
import {UserData} from '../Interfaces/UserData';
import {initializeLoginKeyRedirect} from '../../DriveSelection/Utility/LoginRedirectKeyListenerUtility';

@Component({
  props: {
    url: String,
    myAccount: String,
    isExtranet: Boolean,
    isMobile: Boolean,
    initialUserData: Object,
  },
  components: {Fragment, LoginExtranet, LoginMobile, LoginWorldWide},
})
export default class LoginStatus extends Vue {
  logoutUrl: string = '';
  loginUrl: string = '';
  myDataUrl: string = '';
  extranetDataUrl: string = '';
  extranetRegisterUrl: string = '';

  state: LoginState = 'loggedOut';

  username: string = '';
  firstName: string = '';
  lastName: string = '';
  usergroup: string = '';

  loginName: string = '';
  loginPassword: string = '';
  defaultFeUserPid: number = 0;
  passwordForgottenHash: string = '';
  hover: string = '';

  url?: string;
  myAccount?: string;
  isExtranet?: boolean;
  isMobile?: boolean;
  initialUserData?: UserData;

  label = {
    login: '',
    myData: '',
    logout: '',
    loggedInAs: '',
    loginNamePlaceholder: '',
    passwordPlaceholder: '',
    loginSubmitButton: '',
    backToLoginLink: '',
    passwordForgottenLink: '',
    passwordForgottenDescriptionMessage: '',
    passwordForgottenPlaceholder: '',
    passwordForgottenSubmitButton: '',
    passwordForgottenSucceededMessage: '',
  };

  async mounted() {
    if (!this.url) {
      throw new Error('url not set.');
    }
    if (!this.initialUserData || this.initialUserData.error) {
      this.onError(this.initialUserData);
      return;
    }
    this.setData(this.initialUserData);
    initializeLoginKeyRedirect(this.myDataUrl);
  }

  async login() {
    const result = await this.sendRequest({
      url: this.url,
      method: 'POST',
      data: {
        user: this.loginName,
        pass: this.loginPassword,
        logintype: 'login',
        pid: this.defaultFeUserPid,
      },
    });
    if (result) {
      this.loginName = '';
      this.loginPassword = '';
      location.reload();
    }
    return false;
  }

  async passwordForgotten() {
    const url = this.url;
    if (!url) {
      throw new Error('url not set.');
    }
    const fullUrl = url + (url.match(/\?/) ? '&' : '?') + $.param({tx_felogin_pi1: {forgot: '1'}});
    await this.sendRequest({
      url: fullUrl,
      method: 'POST',
      data: {
        tx_felogin_pi1: {
          forgot_hash: this.passwordForgottenHash,
          forgot_email: this.loginName,
        },
      },
    });
    this.setLoginState('passwordForgottenMessage');
    return false;
  }

  private async sendRequest(options: string | {} | any): Promise<boolean> {
    const userData = await $.ajax(options);
    if (userData.error) {
      this.onError(userData);
      return false;
    }
    this.setData(userData);
    return true;
  }

  private setData(userData): void {
    this.logoutUrl = userData.logoutUrl;
    this.loginUrl = userData.loginUrl;
    this.myDataUrl = userData.myDataUrl;
    this.extranetDataUrl = userData.extranetDataUrl;
    this.extranetRegisterUrl = userData.extranetRegisterUrl;
    this.username = userData.username;
    this.firstName = userData.firstname;
    this.lastName = userData.lastname;
    this.usergroup = userData.usergroup;
    this.label = {...this.label, ...userData.labels};
    if (userData.loggedIn === true) {
      this.setLoginState('loggedIn');
    } else {
      this.onError(userData);
    }
  }

  private onError(userData): void {
    this.setLoginState('loggedOut');
    this.defaultFeUserPid = userData.defaultFeUserPid;
    this.passwordForgottenHash = userData.hash;
    this.label = {...this.label, ...userData.labels};
  }

  private setLoginState(state: LoginState): void {
    this.state = state;
    setLoginStateGlobally(state, this.usergroup);
  }
}
